import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { Alert } from '../../core/models/alert.model';
import { MatTabsModule } from '@angular/material/tabs';
import { GeneralComponent } from '../general/general.component';
import { Constants } from '../../shared/utils/constants';
import { UpdateRecordService } from '../../core/services/update-record.service';
import { MatDialog } from '@angular/material/dialog';
import { UpdateRecord } from '../../core/models/update-record.model';
import { ModalComponent } from '../modal/modal.component';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ShiftClosureService } from '../../core/services/shift-closure.service';
import { AuthService } from '../../core/services/auth.service';
import { ShiftClosure } from '../../core/models/shift-closure.model';

@Component({
  selector: 'app-subestacion',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
    MatTableModule,
    MatTabsModule,
    GeneralComponent,
  ],
  templateUrl: './subestacion.component.html',
  styleUrl: './subestacion.component.scss',
})
export class SubestacionComponent implements OnInit {
  alerts: Alert[] = [];
  flattenedData: { [key: string]: any[] } = {
    [Constants.NOVEDADES]: [],
    [Constants.AVISO_AVERIAS]: [],
    [Constants.OT_EJECUTADAS]: [],
    [Constants.FUERA_SERVICIO]: [],
  };

  tableColumns: TableColumn[] = [
    { header: 'Seleccionar', field: 'isMarkedForClosure', isCheckbox: true, showSelectAll: true, width: '120px' },
    { header: 'Hora', field: 'hora', width: '100px' },
    //  { header: 'Responsable', field: 'responsable' },
    { header: 'Novedad', field: 'novedad', width: '60%' },
    { header: 'Fecha', field: 'fecha', isDate: true, width: '120px' },
  ];

  isShiftSupervisor: boolean = false
  isDCSOperator: boolean = false
  isAreaOperator: boolean = false


  constructor(
    private updateRecordService: UpdateRecordService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private shiftClosureService: ShiftClosureService,
    private authService: AuthService
  ) { }

  async ngOnInit(): Promise<void> {

    this.isShiftSupervisor = this.authService.hasRole('novedades');
    this.isDCSOperator = this.authService.hasRole('Novedades_Operador_DCS');
    this.isAreaOperator = this.authService.hasRole('Novedades_Operador_Ferrico') || this.authService.hasRole('Novedades_Salmuera_I') || this.authService.hasRole('Novedades_Salmuera_II') || this.authService.hasRole('Novedades_Compresion') || this.authService.hasRole('Novedades_Electrolizadores') || this.authService.hasRole('Novedades_Subestacion') || this.authService.hasRole('Novedades_Movimiento_Producto');

    if (this.isShiftSupervisor) return this.loadAndFilterByShiftSupervisor()
    if (this.isDCSOperator) return this.loadAndFilterByDCSOperator()
    if (this.isAreaOperator) return this.loadAndFilterByAreaOperator()

    // this.loadData(Constants.NOVEDADES);
    // this.loadData(Constants.AVISO_AVERIAS);
    // this.loadData(Constants.OT_EJECUTADAS);
    // this.loadData(Constants.FUERA_SERVICIO);
  }

  private async loadAndFilterByShiftSupervisor() {
    const shiftId = await this.getShiftId()
    if (!shiftId) return //si no hay turno abierto, termina la ejecucion 
    const actualShiftClosure: ShiftClosure | null = await this.getShiftClosure(shiftId);
    if (!actualShiftClosure) return
    this.loadDataByShiftSupervisor(Constants.NOVEDADES, actualShiftClosure);
    this.loadDataByShiftSupervisor(Constants.AVISO_AVERIAS, actualShiftClosure);
    this.loadDataByShiftSupervisor(Constants.OT_EJECUTADAS, actualShiftClosure);
    this.loadDataByShiftSupervisor(Constants.FUERA_SERVICIO, actualShiftClosure);
  }

  private async loadAndFilterByDCSOperator() {
    const shiftId = await this.getShiftId()
    if (!shiftId) return //si no hay turno abierto, termina la ejecucion 
    const actualShiftClosure: ShiftClosure | null = await this.getShiftClosure(shiftId);
    if (!actualShiftClosure) return
    this.loadDataByDCSOperator(Constants.NOVEDADES, actualShiftClosure);
    this.loadDataByDCSOperator(Constants.AVISO_AVERIAS, actualShiftClosure);
    this.loadDataByDCSOperator(Constants.OT_EJECUTADAS, actualShiftClosure);
    this.loadDataByDCSOperator(Constants.FUERA_SERVICIO, actualShiftClosure);
  }

  private loadAndFilterByAreaOperator() {
    this.loadDataByAreaOperator(Constants.NOVEDADES);
    this.loadDataByAreaOperator(Constants.AVISO_AVERIAS);
    this.loadDataByAreaOperator(Constants.OT_EJECUTADAS);
    this.loadDataByAreaOperator(Constants.FUERA_SERVICIO);
  }

  private async getShiftId(): Promise<number | null> {

    try {
      const shiftId: number = await firstValueFrom(this.shiftClosureService.getOpenShiftByType(Constants.INFORME_TURNO))
      return shiftId ? shiftId : null
    } catch (error: any) {
      if (error?.status === 404) {
        return null;
      } else {
        //redirigir a vista enterior
        return null;
      }
    }
  }

  private async getShiftClosure(shiftId: number): Promise<ShiftClosure | null> {
    try {
      const response = firstValueFrom(this.shiftClosureService.getShiftClosureById(shiftId))
      return response
    } catch {
      return null
    }
  }

  private filterByShiftClosureDate(actualShiftClosure: ShiftClosure, updatedRecords: UpdateRecord[]): UpdateRecord[] {

    const actualShiftClosureDate: Date = new Date(actualShiftClosure.startUtc)
    const tsAperturaReporte = actualShiftClosureDate.getTime();
    //console.log(`Se filtra para un turno abierto, que comenzo el ${this.formatearFecha(actualShiftClosure.startUtc)} `)

    return updatedRecords.filter(item => {
      //const itemDate = new Date(item.createdUtc + 'Z');
      const itemDate = new Date(item.createdUtc);

      if (isNaN(itemDate.getTime())) {
        console.warn(`Fecha inválida encontrada en el ítem: ${item.createdUtc}`);
        return false;
      }

      const tsItem = itemDate.getTime();
      return tsItem >= tsAperturaReporte;
    });
  }


  loadDataByShiftSupervisor(type: string, actualShiftClosure: ShiftClosure): void {
    this.updateRecordService.getUpdateRecordsByTypeAndAreas__bySections(type, [Constants.SUBESTACION]).subscribe({
      next: (updates: UpdateRecord[]) => {
        const updatesFilterByDate = this.filterByShiftClosureDate(actualShiftClosure, updates)
        const flattened = this.flattenData(updatesFilterByDate);
        this.flattenedData[type] = flattened.length ? flattened : [];
      },
      error: error => {
        if (error.status === 404) {
          this.flattenedData[type] = [];
        } else {
          console.error(`Error al cargar los datos para el tipo ${type}:`, error);
          this.flattenedData[type] = [];
        }
      },
    });
  }


  loadDataByDCSOperator(type: string, actualShiftClosure: ShiftClosure): void {
    this.updateRecordService.getUpdateRecordsByTypeAndAreas__bySections__dcs(type, [Constants.SUBESTACION]).subscribe({
      next: (updates: UpdateRecord[]) => {
        const updatesFilterByDate = this.filterByShiftClosureDate(actualShiftClosure, updates)
        const flattened = this.flattenData(updatesFilterByDate);
        //const flattened = this.flattenData(updates);
        this.flattenedData[type] = flattened.length ? flattened : [];
      },
      error: error => {
        if (error.status === 404) {
          this.flattenedData[type] = [];
        } else {
          console.error(`Error al cargar los datos para el tipo ${type}:`, error);
          this.flattenedData[type] = [];
        }
      },
    });
  }

  loadDataByAreaOperator(type: string): void {
    const isClosed = false;
    const isMarkedForClosure = undefined;
    const isMarkedForPreClosure = false;
    this.updateRecordService.getUpdateRecordsByTypeAndAreas(type, [Constants.SUBESTACION], isClosed, isMarkedForClosure, isMarkedForPreClosure).subscribe({
      next: (updates: UpdateRecord[]) => {
        const flattened = this.flattenData(updates);
        this.flattenedData[type] = flattened.length ? flattened : [];
      },
      error: error => {
        if (error.status === 404) {
          this.flattenedData[type] = [];
        } else {
          console.error(`Error al cargar los datos para el tipo ${type}:`, error);
          this.flattenedData[type] = [];
        }
      },
    });
  }

  newUpdateRecord(type: string) {
    // Verificar si hay un turno abierto antes de abrir el modal (user-scoped)
    this.shiftClosureService.getOpenShiftByType('informe_turno').subscribe({
      next: (shiftId: number) => {
        if (!shiftId) {
          alert('Error: No existe un turno abierto para registrar información');
        } else {
          const dialogRef = this.dialog.open(ModalComponent, {
            data: { type, area: Constants.SUBESTACION },
            width: '600px',
          });

          dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
            if (result?.success) {
              //this.loadDataByAreaOperator(type);
              this.refreshAll()
            }
          });
        }
      },
      error: (error) => {
        alert('Error: No existe un turno abierto para registrar información');
        console.error('Error al verificar el turno abierto:', error);
      }
    });
  }

  // Determina la marca de cierre a mostrar según rol y/o área del registro
  private getRoleSpecificClosureMark(update: UpdateRecord): boolean {
    const u: any = update as any;
    const isDcs = this.authService.hasRole('Novedades_Operador_DCS') || this.authService.hasRole('DCS') || this.authService.hasRole('dcs');
    const isFerrico = this.authService.hasRole('Novedades_Operador_Ferrico') || this.authService.hasRole('Novedades_Subestacion') || this.authService.hasRole('FERRICO') || this.authService.hasRole('ferrico');
    if (isDcs) {
      return (u.isMarkedForClosureDCS ?? u.isMarkedForClosureDcs ?? update.isMarkedForClosure) as boolean;
    }
    if (isFerrico) {
      return (u.isMarkedForClosureFerrico ?? update.isMarkedForClosure) as boolean;
    }
    return update.isMarkedForClosure;
  }

  flattenData(updates: UpdateRecord[]): any[] {
    return updates.flatMap(update => {
      const horaElement = update.updateElements.find(el => el.label === 'Hora' || el.label === 'Hora Inicio');
      let novedadElement, novedad;
      novedadElement = update.updateElements.find(el => el.label === 'Novedad');
      const createdByUser = update.updateElements?.find(el => el.element?.id === 2 || el.element?.id === 5)
        ?.updateValues?.[0]?.createdUser;
      const responsibleId = (update as any)?.responsible?.id ?? createdByUser?.id ?? null;
      novedad = update.updateElements
        .filter(element => !(element.label === 'Hora' || element.element.name === 'Label'))
        .map(element => {
          // Concatenar el label con los valores de updateValues
          const values = element.updateValues
            .map(val => {
              let display;
              if (val.value === "true") display = "Si";
              else if (val.value === "false") display = "No";
              else display = val.value;
              return `${element.label}: ${display}`;
            })
            .join(', ');
          return values || `${element.label}: N/A`; // Si no hay valores, mostrar el label con N/A
        })
        .filter(text => text) // Eliminar elementos vacíos
        .join(', '); // Unir todos los elementos con coma
      return {
        id: update.id,
        hora: horaElement?.updateValues[0]?.value || '',
        responsable:
          update.updateElements?.find(el => el.element?.id === 2 || el.element?.id === 5)
            ?.updateValues[0]?.createdUser?.username || '',
        createdById: createdByUser?.id ?? update.updateElements?.[0]?.updateValues?.[0]?.createdUser?.id ?? null,
        responsibleId,
        novedad: novedadElement ? novedadElement.updateValues[0]?.value || '' : novedad,
        fecha:
          update.updateElements?.find(el => el.element?.id === 2 || el.element?.id === 5)
            ?.updateValues[0]?.createdUtc || '',
        updateElements: update.updateElements,
        updateType: update.updateType,
        updateArea: update.updateArea,
        isMarkedForClosure: this.getRoleSpecificClosureMark(update),
      };
    });
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  viewUpdateRecord(updateRecord: UpdateRecord): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord,
        readOnly: true,
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  onCheckboxChange(isMarked: boolean, updateRecordId: number): void {
    this.updateRecordService.updateMarkForClosure(updateRecordId, isMarked).subscribe({
      next: () => {
        console.log('Estado actualizado correctamente.');
      },
      error: (error) => {
        console.error('Error al actualizar el estado:', error);

        // Revertir el cambio visual en caso de error
        Object.values(this.flattenedData).forEach((dataArray: any[]) => {
          const record = dataArray.find((item: any) => item.id === updateRecordId);
          if (record) {
            record.isMarkedForClosure = !isMarked;
          }
        });
      },
    });
  }

  onSelectAllChange(event: { checked: boolean; type: string; visibleData?: any[] }): void {
    const isChecked = event.checked;
    const tableType = event.type;

    let dataArray: any[] = [];

    // Si tenemos visibleData, usar solo los datos visibles; si no, usar todos los datos
    if (event.visibleData && event.visibleData.length > 0) {
      dataArray = event.visibleData;
    } else {
      // Determinar qué array de datos actualizar según el tipo de tabla
      switch (tableType) {
        case 'novedades':
          dataArray = this.flattenedData['novedades'] || [];
          break;
        case 'aviso_averias':
          dataArray = this.flattenedData['aviso_averias'] || [];
          break;
        case 'o_t_ejecutadas':
          dataArray = this.flattenedData['o_t_ejecutadas'] || [];
          break;
        case 'fuera_servicio':
          dataArray = this.flattenedData['fuera_servicio'] || [];
          break;
        default:
          console.warn('Tipo de tabla no reconocido:', tableType);
          return;
      }
    }

    // Si no hay datos, salir
    if (!dataArray || dataArray.length === 0) {
      console.warn('No hay datos para actualizar en el tipo de tabla:', tableType);
      return;
    }

    // Filtrar solo los elementos que realmente necesitan cambio de estado
    const itemsToUpdate = dataArray.filter((item: any) => {
      return item && item.id && item.isMarkedForClosure !== isChecked;
    });

    if (itemsToUpdate.length === 0) {
      console.log('Todos los elementos visibles ya tienen el estado deseado.');
      return;
    }

    // Actualizar visualmente solo los elementos que van a cambiar
    itemsToUpdate.forEach((item: any) => {
      item.isMarkedForClosure = isChecked;
    });

    // Realizar las llamadas a la API solo para los elementos que cambiaron
    const requests = itemsToUpdate.map((item: any) =>
      this.updateRecordService.updateMarkForClosure(item.id, isChecked)
    );

    // Usar forkJoin para manejar múltiples solicitudes en paralelo
    forkJoin(requests).subscribe({
      next: () => {
        console.log(`Se actualizaron ${requests.length} registros correctamente.`);
      },
      error: (error) => {
        console.error('Error al actualizar algunos registros:', error);

        // En caso de error, revertir los cambios visuales solo en los elementos que se intentaron cambiar
        itemsToUpdate.forEach((item: any) => {
          item.isMarkedForClosure = !isChecked;
        });
      }
    });
  }

  canAccess(feature: string): boolean {
    return this.authService.canAccess(feature);
  }

  deleteUpdateRecord(id: number): void {
    if (confirm('¿Estás seguro de que deseas eliminar este registro?')) {
      this.updateRecordService.deleteUpdateRecord(id).subscribe({
        next: () => {
          console.log(`Registro con ID ${id} eliminado correctamente.`);
          this.refreshAll();
        },
        error: error => {
          console.error(`Error al eliminar el registro con ID ${id}:`, error);
          if (error?.status === 500) {
            alert('No es posible eliminar el registro. Ya forma parte de un Cierre de Turno de otro usuario');
          } else {
            alert('Ocurrió un error al eliminar el registro. Intenta nuevamente.');
          }
        },
      });
    }
  }

  editUpdateRecord(updateRecord: any): void {
    if (!updateRecord.updateElements) {
      console.error('El objeto no tiene elementos de actualización:', updateRecord);
      return;
    }

    const dialogRef = this.dialog.open(ModalComponent, {
      data: {
        record: updateRecord, // Pasar los datos del registro
        readOnly: false, // Permitir edición
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
      if (result?.success) {
        console.log('Edición realizada con éxito. Actualizando datos...');
        this.refreshAll();
      }
    });
  }

  // Visibilidad de acciones
  canEdit(item: any): boolean {
    const uid = this.authService.getUserId();
    if (!uid) return false;
    // Prioridad: responsible.id (desde API). Fallback: createdById (derivado de createdUser)
    if (typeof item?.responsibleId === 'number') {
      return item.responsibleId === uid;
    }
    return item?.createdById === uid;
  }

  canDelete(item: any): boolean {
    const uid = this.authService.getUserId();
    if (!uid) return false;
    if (typeof item?.responsibleId === 'number') {
      return item.responsibleId === uid;
    }
    return item?.createdById === uid;
  }

  private async refreshAll(): Promise<void> {

    if (this.isShiftSupervisor) return this.loadAndFilterByShiftSupervisor()
    if (this.isDCSOperator) return this.loadAndFilterByDCSOperator()
    if (this.isAreaOperator) return this.loadAndFilterByAreaOperator()

    // this.loadDataByAreaOperator(Constants.NOVEDADES);
    // this.loadDataByAreaOperator(Constants.AVISO_AVERIAS);
    // this.loadDataByAreaOperator(Constants.OT_EJECUTADAS);
    // this.loadDataByAreaOperator(Constants.FUERA_SERVICIO);
  }
}
